export default "__VITE_ASSET__dBSs2Vw3__"